var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid",attrs:{"id":"category_wrap"}},[_c('ForumList',{attrs:{"category":this.$route.params.slug}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }